module.exports = __webpack_public_path__ + "static/img/third2_2_5.684d3d75.jpg";